import { render, staticRenderFns } from "./EmployeeRolesModalForm.vue?vue&type=template&id=311a3810&scoped=true&"
import script from "./EmployeeRolesModalForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeRolesModalForm.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRolesModalForm.vue?vue&type=style&index=0&id=311a3810&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a3810",
  null
  
)

export default component.exports